export const dictionary = {
  ADD_TO_CART: {
    ES: "Añadir al carrito",
    EN: "Add to cart",
  },
  ADD: {
    ES: "Añadir",
    EN: "Add",
  },
  BACK_TO_MENU: {
    ES: "Volver al menú",
    EN: "Back to menu",
  },
  PRODUCT_NOT_AVAILABLE: {
    ES: "Producto temporalmente no disponible",
    EN: "Product not available",
  },
  SELECT_ONE: {
    ES: "(Selecciona uno)",
    EN: "(Select one)",
  },
  NOT_AVAILABLE: {
    ES: "No disponible",
    EN: "Not available",
  },
} as const;
